import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from '../../notifications.service';
import packageJson from '../../../../package.json';

interface NavItem {
  icon: string;
  label: string;
  route: string;
  ariaLabel: string;
}

@Component({
  selector: 'app-bottom-nav',
  templateUrl: './bottom-nav.component.html',
  styleUrls: ['./bottom-nav.component.scss'],
})
export class BottomNavComponent {
  version: string = packageJson.version;

  navItems: NavItem[] = [
    { icon: 'home', label: 'Accueil', route: '/home', ariaLabel: 'Accueil' },
    { icon: 'account_circle', label: 'Profil', route: '/account', ariaLabel: 'Mon compte' },
    { icon: 'check_box', label: 'Pronos', route: '/pronos', ariaLabel: 'Pronostics' },
    { icon: 'how_to_vote', label: 'Votes', route: '/consultations', ariaLabel: 'Consultations' },
    { icon: 'lightbulb', label: 'Suggestions', route: '/suggestions', ariaLabel: 'Suggestions' },
    { icon: 'folder_open', label: 'Documents', route: '/documents', ariaLabel: 'Documents' },
  ];

  constructor(
    public notificationsService: NotificationsService,
    private router: Router
  ) {}

  getBadgeCount(route: string): number {
    const n = this.notificationsService.notifications;
    switch (route) {
      case '/account':
        return n.compteIssues + n.socioIssues;
      case '/pronos':
        return n.receivePronoNotifications !== false ? n.missingPronostics : 0;
      case '/consultations':
        return n.consultationsAvailable;
      case '/suggestions':
        return n.suggestionIssues;
      case '/documents':
        return n.unreadDocs;
      default:
        return 0;
    }
  }

  isBadgeHidden(route: string): boolean {
    return this.getBadgeCount(route) === 0;
  }

  /** Actif aussi sur les sous-pages (ex. /pronos/classement), hors paramètres d'adresse */
  isActive(route: string): boolean {
    const url = this.router.url.split(/[?#]/)[0];
    return url === route || url.startsWith(route + '/');
  }
}
